import { LatLngTuple, divIcon } from 'leaflet';
import React from 'react';
import { Marker, MapContainer, TileLayer, Popup } from 'react-leaflet';

export interface MapProps {
    markers: Markers[];
}

export interface Markers {
    coordinates: LatLngTuple;
    message: string;
    color: string | undefined;
    id: string;
}

const LeafletMap = (props: MapProps) => {
    if (props.markers?.length > 0) {
        return (
            <MapContainer
                style={{ height: '100%', borderRadius: '8px', border: '2px solid #2196f3' }}
                center={props.markers[0].coordinates}
                zoom={15}
                scrollWheelZoom={false}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {props.markers &&
                    props.markers.map((marker) => {
                        if (marker == undefined || marker.coordinates == undefined) {
                            return;
                        }

                        const myCustomColour = marker.color;

                        const markerHtmlStyles = `
                    background-color: ${myCustomColour};
                    width: 1.5rem;
                    height: 1.5rem;
                    display: block;
                    left: -1.5rem;
                    top: -1.5rem;
                    position: relative;
                    border-radius: 3rem 3rem 0;
                    transform: rotate(45deg);
                    border: 1px solid #FFFFFF`;

                        const icon = divIcon({
                            className: '',
                            html: `<span style="${markerHtmlStyles}" />`
                        });
                        return (
                            <div key={marker.id}>
                                <Marker icon={icon} position={marker.coordinates}>
                                    {marker.message ? <Popup content={marker.message}></Popup> : <span></span>}
                                </Marker>
                            </div>
                        );
                    })}
            </MapContainer>
        );
    } else {
        return <div></div>;
    }
};

export default LeafletMap;
